<div class="container">
    <div class="text-center m-5">
        <h1>CrossOver Analisi H4</h1>
    </div>
    <div class="row mt-5">
        <div class="col-12 text-end">
            <span class="m-3" *ngIf="loading">
                <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </span>
            <button type="button" class="btn btn-primary" (click)="aggiorna()" [disabled]="loading">Aggiorna dati CrossOver</button>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <table class="table">
                <thead>
                    <tr>
                        <th *ngFor="let h of headers" scope="col">{{h}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let r of datiTable">
                        <td>{{r.ora}}</td>
                        <td>{{r.eur}}</td>
                        <td>{{r.usd}}</td>
                        <td>{{r.gbp}}</td>
                        <td>{{r.jpy}}</td>
                        <td>{{r.aud}}</td>
                        <td>{{r.nzd}}</td>
                        <td>{{r.cad}}</td>
                        <td>{{r.chf}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="row mt-5">
        <div class="col-3 text-end">
            Valori nel grafico
            <select class="form-control" (change)="valoriGrafico($event)">
                <option value="100">100</option>
                <option value="200">200</option>
                <option value="300">300</option>
                <option value="400">400</option>
                <option value="500">500</option>
            </select>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <highcharts-chart [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="chartOptions"
                [(update)]="updateFlag" [oneToOne]="oneToOneFlag" [runOutsideAngular]="runOutsideAngularFlag"
                style="width: 100%; height: 600px; display: block;"></highcharts-chart>
        </div>
    </div>
    
    <div class="row mt-5">
        <div class="col">
            <p class="h3 text-center">Analisi cambio</p>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <app-lista-pulsanti-mercati [soloForex]="true"
                (mercatoSelezionato)="mercatoSelezionato($event)"></app-lista-pulsanti-mercati>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <highcharts-chart [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="chartOptions2"
                [(update)]="updateFlag" [oneToOne]="oneToOneFlag" [runOutsideAngular]="runOutsideAngularFlag"
                style="width: 100%; height: 600px; display: block;"></highcharts-chart>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <highcharts-chart [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="chartOptions3"
                [(update)]="updateFlag" [oneToOne]="oneToOneFlag" [runOutsideAngular]="runOutsideAngularFlag"
                style="width: 100%; height: 600px; display: block;"></highcharts-chart>
        </div>
    </div>
</div>
